import { httpservice } from './httpService'
import { getToken } from './tokenStore'

/**
 * OTP Send
 */
export function sendOTP(phone) {
    return httpservice()
        .post(`/api/client/auth/sendOtp/${phone}`)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Verify mobile
 */
export function verifyMobile(phone) {
    return httpservice()
        .post(`/api/client/verifyMobile/${phone}`)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Verify OTP
 */
export function verifyOTP(otpData) {
    return httpservice()
        .post(`/api/client/auth/verifyOtp/`, otpData)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Sign UP
 */
export function signUP(signUpData) {
    return httpservice()
        .post(`/api/client/verifyUser/${signUpData?.mobileNumber}/${signUpData?.pin}`, signUpData)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}
/**
 * Pin Verify
 */
export function verifyPin(pin) {
    return httpservice()
        .post(`/api/client/verifyPin/${pin}`, )
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Validate Pincode V2
 */
export function getPincdoeDetails(pincode) {
    return httpservice()
        .get(`/api/pincode/${pincode}`, )
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.response
        })
}

//**SignUP OTP Verification */

/**
 * Sign UP
 */
export function signUPOTP(signUpData) {
    return httpservice()
        .post('/api/client/signup', signUpData)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Sign UP
 */
export function saveDetails(signUpData) {
    return httpservice()
        .post('/api/userData/signup-details', signUpData)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Store Current Address
 */
export function saveCurrentAddress(addressData) {
    return httpservice()
        .post('/api/userData/current-address', addressData)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Pin Verify
 */
export function verifyPanExtensive(obj) {
    return httpservice()
        .post(`/api/pan`, obj)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * PAN Verify OnGrid
 */
export function verifyPANOnGrid(obj) {
    return httpservice()
        .post(`/api/ongrid/verify-pan`, obj)
        .then(function (response) {
             console.log("verifyPANOnGrid Service>>>", response);
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * PAN Status OnGrid
 */
export function getPANStatus(userId) {
    return httpservice()
        .get(`/api/ongrid/pan-status/${userId}`)
        .then(function (response) {
             console.log("getPANStatus Service>>>", response);
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * PAN Details 
 */
export function getPANDetails(userId) {
    return httpservice()
        .get(`/api/ongrid/pan-details/${userId}`)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
    }

/**
 * Equifax Soft pull
 */
export function equifaxSoftPull(panDetailId) {
    return httpservice()
        .get(`api/client/equifax/soft/${panDetailId}`)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}


/**
 * Eligibility Check
 */
export function loanEligibilityCheck(obj) {
    return httpservice()
        .post(`/api/userData/userLoanEligibilityCheck`, obj)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * consent Check
 */
export function userConsent(obj) {
    return httpservice()
        .post(`/api/userData/userConsent`, obj)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * consent Check
 */
export function saveUserConsent(userId,consent) {
    return httpservice()
        .put(`/api/userData/consent/${userId}?consentType=${consent}`)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}



/**
 * Admin Login
 */
 export function adminLoginAPI(obj) {
    return httpservice()
        .post('/api/client/auth/adminLogin/', obj)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Admin Login
 */
 export function OTPForgotPassword(mobileNumber,userName) {
    return httpservice()
        .post(`api/client/auth/forgotPassword/${mobileNumber}/${userName}`)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Admin Login
 */
 export function resetPassword(obj) {
    return httpservice()
        .put(`/api/client/auth/updateUserPassword?mobileNumber=${obj?.mobileNumber}&password=${obj?.password}`,)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Verify email token (public endpoint)
 */
export function verifyEmailToken(token) {
    return httpservice()
        .get(`/api/client/email/verify?token=${encodeURIComponent(token)}`)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Resend verification email (authenticated)
 */
export function resendVerificationEmail() {
    return httpservice()
        .post('/api/client/email/resend')
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Poll email verification status (authenticated) — used by face-match email gate
 */
export function getEmailVerificationStatus() {
    return httpservice()
        .get('/api/client/email/status')
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * Change email and trigger new verification link (authenticated)
 */
export function changeEmailAndResend(newEmail) {
    return httpservice()
        .put(`/api/client/email/change?email=${encodeURIComponent(newEmail)}`)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

/**
 * User Logout
 */
export function userLogout() {
    const jwt = getToken()
    return httpservice()
        .post(`api/client/auth/logout`, null, jwt ? { headers: { Authorization: 'Bearer ' + jwt } } : {})
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })
}

